import React from 'react';
import Apploader from '../../components/loader/loader'
import { connect } from 'dva';
import { Card, Typography, Input, Button, Table, Row,Avatar, Col, Popconfirm } from 'antd';
import { DeleteOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios';



// import AddEdit from './action/addEdit'
const { Search } = Input;
const { Text } = Typography;
const baseUrl = process.env.REACT_APP_ApiUrl;


class OrderList extends React.Component {
	constructor(props) {
		super(props);
		this.state = { limit: 10, current: 0, sortBy: 'asc', searchText: '', loader: false, count: 0, listData: [] , isAdmin : false  }
		setTimeout(() => document.title = 'Order List', 100);
	}

	componentDidMount() {
		this.ListFun();
		
		if(localStorage.getItem('role') === "ADMIN"){
			this.setState({isAdmin : true})
		}
	}

	ListFun = () => {
		let searchData = { limit: this.state.limit, page: this.state.current, sortBy: this.state.sortBy }
		this.props.dispatch({ type: 'orders/listData', payload: searchData });
	}

	ShowSizeChange = (current, size) => {
		this.setState({ limit: size, current: current - 1 }, () => this.ListFun())
	};

	// paginationFun = (val) => this.setState({ current: val.current }, () => this.ListFun());
	paginationFun = (val) => this.setState({ current: val.current - 1 }, () => this.ListFun());

	searchVal = (val) => {
		this.state.searchText = val;
		const resultAutos = this.props.orders.list.filter((auto) =>
			JSON.stringify(auto).toLowerCase().includes(val.toLowerCase())
		)
		this.setState({ listData: resultAutos })
	}


	deleteItem = (_id) => {
		let val = { _id }
		this.props.dispatch({ type: 'orders/delete', payload: val });
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (snapshot) {
			this.ListFun();
		}
	}


	handleDeactiveUser = async (data) => {
		let list = this.state.listData;
		console.log("list" , list)
		let list_update = list.map((item) => {
			if(item._id === data) {
				item.status = !item.status;
			}
			return item;	
		})
		this.setState({ listData: list_update })
		await axios.post(`${baseUrl}/api/order/status`, {id: data});
	}


	render() {
		const { location } = this.props;
		const pathSnippets = location.pathname.split('/').filter(i => i);
		let url = pathSnippets[0].toUpperCase();

		const { searchText } = this.state;
		const { orders } = this.props;
		const count = orders?.count;


		if (this.state.searchText == '') {
			this.state.listData = orders ? orders.list : [];
		}


		const columns = [

			{
				title: <strong className=''>Order ID</strong>, dataIndex: 'order_number_readable',
				render: (value, row) => {
					return <span className='text-primary'>{row.order_number_readable || row._id}</span>
				}
			},

		{
    title: <strong className=''>Customer Mobile</strong>, dataIndex: 'user_id',
    render: (value, row) => {
        return <span className='time_table_text'>{row.customerInfo?.mobile_number || '-'}</span>
    }
},

			{
				title: <strong className=''>Seller Name</strong>, dataIndex: 'storeInfo',
				render: (value, row) => {
					return <span className='time_table_text'>{row.storeInfo?.title || '-'}</span>
				}
			},

			// {
			// 	title: <strong className=''>Total Amount</strong>, dataIndex: 'total_amount',
			// 	render: (value, row) => {
			// 		return <span className='time_table_text'>₹{row.total_amount}</span>
			// 	}
			// },
// {
//     title: <strong>Total Amount (MRP)</strong>, dataIndex: 'total_amount',
//     render: (value, row) => {
//         const total = Number(row.payable_amount) + Number(row.discounted_amount);
//         return <span className='time_table_text'>₹{total}</span>
//     }
// },

// {
//     title: <strong>Total Amount (MRP)</strong>,
//     render: (value, row) => {
//         const payable = Math.ceil(Number(row.payable_amount));
//         const discount = Number(row.discounted_amount);

//         const gst = parseFloat((payable * 5 / 105).toFixed(2));
//         const mrp = parseFloat((payable - gst + discount).toFixed(2));

//         return <span className='time_table_text'>₹{mrp}</span>
//     }
// },
{
    title: <strong>Total Amount (MRP)</strong>,
    render: (value, row) => {

        const payable = Number(row.payable_amount || 0);
        const discount = Number(row.discounted_amount || 0);

        let mrp = 0;

        // For Flat Discount Orders
        if (row.order_type === "FLAT_DISCOUNT_PIN") {

            mrp = payable + discount;

        } else {

            // Remove 5% GST from payable
            const baseAmount = payable / 1.05;

            mrp = Math.floor(baseAmount + discount);
        }

        return (
            <span className='time_table_text'>
                ₹{mrp}
            </span>
        );
    }
},
// {
//     title: <strong>Total Amount (MRP)</strong>,
//     render: (value, row) => {
//         const payable = Number(row.payable_amount || 0);
//         const discount = Number(row.discounted_amount || 0);

//         // Remove GST from payable
//         const baseAmount = payable / 1.05;

//         // Total MRP before discount + GST
//         const mrp = Math.floor(baseAmount + discount);

//         return (
//             <span className='time_table_text'>
//                 ₹{mrp}
//             </span>
//         );
//     }
// },
	

			{
				title: <strong className=''>Discount Amount</strong>, dataIndex: 'discounted_amount',
				render: (value, row) => {
					return <span className='time_table_text'>₹{row.discounted_amount}</span>
				}
			},


				{
				title: <strong className=''>Payable Amount(with 5%Gst)</strong>, dataIndex: 'payable_amount',
				render: (value, row) => {
					return <span className='time_table_text'>₹{row.payable_amount}</span>
				}
			},

			{
				title: <strong className=''>Payment Status</strong>, dataIndex: 'payment_status',
				render: (value, row) => {
					return <span className='time_table_text'>{row.payment_status}</span>
				}
			},

			{
				title: <strong className=''>Order Type</strong>, dataIndex: 'order_type',
				render: (value, row) => {
					return <span className='time_table_text'>{row.order_type}</span>
				}
			},

			{
				title: <strong className='time_table_text'>Order Date & Time</strong>, dataIndex: 'created_at',
				render: (value, row) => {
					return <span className='time_table_text'>{moment(value).format('DD/MM/YYYY hh:mm a')}</span>
				}
			},

			{
				title: <strong>Action</strong>, width: 150,
				render: (val, data) =>
					<div>
						<Button className="eye_btn" type="default" onClick={() => {
							this.props.history.push('/order/view/' + data._id)
						}}><EyeOutlined /></Button>&nbsp;
					</div>
			},
		];

		return (
			<div>
				<Row className="TopActionBar" gutter={[16, 0]} justify="space-between" align="middle">
					<Col>
					{<Search placeholder="Search..." onChange={(e) => this.searchVal(e.target.value)} value={searchText}
							loading={this.props.submitting} />}
					</Col>
				</Row>

				<div className="innerContainer">
					<Card style={{ marginTop: "0" }} bodyStyle={{ padding: '0 15px 15px' }}>
						{/* <Table columns={columns} dataSource={this.state.listData}
							loading={this.props.loading.global}
							rowKey={record => record._id}
							pagination={{
								position: ['bottomLeft'],
								showTotal: (total, range) => <Text type="secondary">{`Showing ${range[0]}-${range[1]} of ${total}`}</Text>,
								showSizeChanger: true,
								responsive: true,
								total: count,
								onShowSizeChange: (current, size) => this.ShowSizeChange(current, size),
								pageSizeOptions: ['10', '25', '50', '100', '250', '500'],
							}}
						/> */}
						<Table columns={columns} dataSource={this.state.listData}
    loading={this.props.loading.global}
    rowKey={record => record._id}
    onChange={this.paginationFun}
    pagination={{
        position: ['bottomLeft'],
        showTotal: (total, range) => <Text type="secondary">{`Showing ${range[0]}-${range[1]} of ${total}`}</Text>,
        showSizeChanger: true,
        responsive: true,
        total: count,
        current: this.state.current + 1,
        pageSize: this.state.limit,
        onShowSizeChange: (current, size) => this.ShowSizeChange(current, size),
        pageSizeOptions: ['10', '25', '50', '100', '250', '500'],
    }}
/>
					</Card>
				</div>
			</div>
		);
	}
};

export default connect(({ orders, loading }) => ({
	orders, loading
}))(OrderList);